import React, { useState } from "react";
import { FormControlLabel, Button, Checkbox } from "@material-ui/core";

export default function ConsultationNotesEHR(props) {
  let btnStatus = props.enabledSaveConsultationBtn;
  const [checked, setChecked] = useState(true);

  const handleChange = (event) => {
    setChecked(event.target.checked);
    props.handleVisibility(!checked);
  };
  return (
    <div className="shadow p-3 m-2 bg-white rounded-lg col-md-12 col-sm-12 position-relative prescription-card">
      <textarea
        name="consultation-notes-txt"
        id="consultation-notes-txt"
        rows="10"
        placeholder="Consultation Notes Here, click to Pen button if you want minimize this section (the text entered will not be lost)"
        className="mb-3 w-100 h-60-custom form-control col-md-12"
        onChange={props.handleConsultationNotes}
        value={props.consultationNotesValue}
      ></textarea>
      <div className="row col-sm-12">
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            props.handleSaveConsultationNotes();
            props.handleRefreshData();
          }}
          className="col-md-6"
          // disabled={!btnStatus}
        >
          Save
        </Button>
        <div className="pl-3">
          <FormControlLabel
            control={<Checkbox checked={checked} onChange={handleChange} />}
            label="Note visible"
          />
        </div>
      </div>
      <div className="col-sm-12 col-md-12 mt-1 text-center">
        <p className="font-weight-bold">{props.responseCNMessage}</p>
      </div>
    </div>
  );
}
